import React from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import {
  PronounSet,
  TicketGender,
} from '../../utils/ticketGenderPronouns';

interface GenderPronounFieldsProps {
  gender: TicketGender;
  pronounSet?: PronounSet;
  onGenderChange: (gender: TicketGender, pronounSet: PronounSet) => void;
  disabled?: boolean;
  genderLabel?: string;
}

/**
 * Gender selector: Male / Female / Not specified only, with no pronoun selector
 * (Lloyd, 31 Oct 2026: "For gender—just do male / female. I don't need the 'other.'
 * Nor do I need any pronoun options anywhere in the system.").
 */
const GenderPronounFields: React.FC<GenderPronounFieldsProps> = ({
  gender,
  onGenderChange,
  disabled = false,
  genderLabel = 'Gender (Optional)',
}) => {
  const handleGenderChange = (event: SelectChangeEvent) => {
    const nextGender = event.target.value as TicketGender;
    onGenderChange(nextGender === 'male' || nextGender === 'female' ? nextGender : '', '');
  };

  const normalizedValue: TicketGender =
    gender === 'male' || gender === 'female' ? gender : '';

  return (
    <FormControl fullWidth>
      <InputLabel id="ticket-gender-label">{genderLabel}</InputLabel>
      <Select
        labelId="ticket-gender-label"
        value={normalizedValue}
        label={genderLabel}
        onChange={handleGenderChange}
        disabled={disabled}
      >
        <MenuItem value="">Not specified</MenuItem>
        <MenuItem value="male">Male</MenuItem>
        <MenuItem value="female">Female</MenuItem>
      </Select>
    </FormControl>
  );
};

export default GenderPronounFields;
